// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-price{display:inline-flex;line-height:.7;flex-grow:1;justify-content:center}.product-price__amount{font-size:1.3em}.product-price__tax{display:flex;align-items:end;font-size:.8em;white-space:nowrap}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
